module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showbar),
      expression: "showbar"
    }],
    staticClass: "header center",
    class: {
      color: _vm.color, showMenu: _vm.showMenu
    }
  }, [(_vm.index == '1' && _vm.$i18n.locale == 'ch') ? _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/nav/logo.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.index == '1' && _vm.$i18n.locale == 'en') ? _c('img', {
    staticClass: "logo logo3",
    attrs: {
      "src": require("../assets/images/nav/logo12.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.index != '1') ? _c('img', {
    staticClass: "logo logo2",
    attrs: {
      "src": require("../assets/images/nav/logo2.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMenu),
      expression: "!showMenu"
    }],
    staticClass: "menu_icon",
    on: {
      "click": function($event) {
        _vm.showMenu = true
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "menu_icon1",
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "menu_down"
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "scroll"
    }
  }, [_c('ul', {
    staticClass: "menu_list"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav1")))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu4 = !_vm.showMenu4
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav11")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu4
    }
  })]), _vm._v(" "), (_vm.showMenu4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/product"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav12")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/product1"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav13")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu4) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/product3"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav15")))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu3 = !_vm.showMenu3
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav2")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu2
    }
  })]), _vm._v(" "), (_vm.showMenu3) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/solution"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav8")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu3) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/solution1"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav9")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu3) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/solution2"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav10")))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link",
    attrs: {
      "to": "/technology"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav3")))])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu1 = !_vm.showMenu1
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav4")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu1
    }
  })]), _vm._v(" "), (_vm.showMenu1) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/devolop"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav17")))])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu2 = !_vm.showMenu2
      }
    }
  }, [_c('a', {
    staticClass: "menu_link"
  }, [_vm._v(_vm._s(_vm.$t("header.nav5")))]), _vm._v(" "), _c('span', {
    staticClass: "nav_icon_down",
    class: {
      nav_icon_up: _vm.showMenu2
    }
  })]), _vm._v(" "), (_vm.showMenu2) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav7")))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenu2) ? _c('li', {
    on: {
      "click": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('router-link', {
    staticClass: "menu_link2",
    attrs: {
      "to": "/join"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav6")))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "button2",
    staticStyle: {
      "margin": "0.46rem 0 1rem 0"
    },
    on: {
      "click": function($event) {
        _vm.free_use()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("header.navBtn")))]), _vm._v(" "), _c('div', {
    staticClass: "change_btns"
  }, [_c('span', {
    class: {
      gray_btn: _vm.$i18n.locale == 'en'
    },
    staticStyle: {
      "padding-right": "0.44rem"
    },
    on: {
      "click": function($event) {
        _vm.changeLanguage('ch', $event)
      }
    }
  }, [_vm._v("中文")]), _vm._v("/"), _c('span', {
    class: {
      gray_btn: _vm.$i18n.locale == 'ch'
    },
    staticStyle: {
      "padding-left": "0.44rem"
    },
    on: {
      "click": function($event) {
        _vm.changeLanguage('en', $event)
      }
    }
  }, [_vm._v("English")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDialog == true),
      expression: "showDialog==true"
    }]
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', [_c('span', {
    staticClass: "closeBtn",
    on: {
      "click": function($event) {
        _vm.showDialog = false;
        _vm.showMenu = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showNext),
      expression: "!showNext"
    }]
  }, [_c('div', [_c('div', {
    staticClass: "dialog_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog_text",
    staticStyle: {
      "margin-bottom": "0.15rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text2'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text3'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {}, [_c('ul', {
    staticClass: "form_list"
  }, [_c('li', [_c('span', {
    staticClass: "input_item input_item1"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('multiselect', {
    attrs: {
      "options": _vm.options,
      "placeholder": "",
      "searchable": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.content_type2),
      callback: function($$v) {
        _vm.content_type2 = $$v
      },
      expression: "content_type2"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('multiselect', {
    attrs: {
      "options": _vm.options1,
      "placeholder": "",
      "searchable": false,
      "allow-empty": false
    },
    model: {
      value: (_vm.content_type2),
      callback: function($$v) {
        _vm.content_type2 = $$v
      },
      expression: "content_type2"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "arrow_icon"
  })], 1)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item2"
  }, [_c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    attrs: {
      "type": "text",
      "placeholder": "公司名称"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Company"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item3"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok2 == 'true'),
      expression: "check_ok2=='true'"
    }],
    staticClass: "check_success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok2 == 'false'),
      expression: "check_ok2=='false'"
    }],
    staticClass: "check_fail"
  }), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "required")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "required")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item4"
  }, [(_vm.$i18n.locale == 'ch') ? _c('span', {
    staticClass: "star"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('span', {
    staticClass: "star"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok3 == 'true'),
      expression: "check_ok3=='true'"
    }],
    staticClass: "check_success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok3 == 'false'),
      expression: "check_ok3=='false'"
    }],
    staticClass: "check_fail"
  }), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "电话"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "phone")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "phone")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "input_item input_item5"
  }, [_c('span', {
    staticClass: "star"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok4 == 'true'),
      expression: "check_ok4=='true'"
    }],
    staticClass: "check_success"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.check_ok4 == 'false'),
      expression: "check_ok4=='false'"
    }],
    staticClass: "check_fail"
  }), _vm._v(" "), _c('span', {
    staticClass: "input_icon"
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "电子邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "email")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.check_success($event, "email")
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "0"
    }
  }, [(_vm.showError) ? _c('span', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "rgb(255,89,89)"
    }
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button2",
    staticStyle: {
      "width": "6.7rem",
      "position": "relative",
      "top": "0.1rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('send'))
    },
    on: {
      "click": function($event) {
        _vm.send_email()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNext),
      expression: "showNext"
    }],
    staticClass: "center"
  }, [_c('img', {
    staticStyle: {
      "width": "1.6rem",
      "height": "1.6rem",
      "padding-top": "3.66rem",
      "margin": "0 auto"
    },
    attrs: {
      "src": require("../assets/images/dialog/success.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "0.36rem",
      "color": "rgb(40,40,40)",
      "margin": "0.4rem 0 0 0rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text8'))
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "0.28rem",
      "color": "rgb(80,80,80)",
      "margin": "0.3rem 0 0 0rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text9'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "0.7rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('text10'))
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0f9eed6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 102
// module chunks = 0